import React, { useEffect, useState } from "react";

import { api } from "../lib/api";

export const TransferProofThumbnail = ({
  saleId,
  available,
  testId,
  className = "",
}) => {
  const [imageUrl, setImageUrl] = useState("");
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    if (!saleId || !available) {
      setImageUrl("");
      setFailed(false);
      return undefined;
    }

    let active = true;
    let nextUrl = "";
    setFailed(false);
    api.get(`/cashier/sale/${saleId}/transfer-proof`, { responseType: "blob" })
      .then((response) => {
        nextUrl = URL.createObjectURL(response.data);
        if (active) {
          setImageUrl(nextUrl);
        }
      })
      .catch(() => {
        if (active) {
          setFailed(true);
        }
      });

    return () => {
      active = false;
      if (nextUrl) {
        URL.revokeObjectURL(nextUrl);
      }
    };
  }, [available, saleId]);

  if (!available) {
    return (
      <span className="text-xs text-wmuted" data-testid={testId}>
        —
      </span>
    );
  }

  if (failed) {
    return (
      <span className="text-xs text-status-reject" data-testid={testId}>
        Tidak dapat dimuat
      </span>
    );
  }

  if (!imageUrl) {
    return (
      <span className="text-xs text-wmuted" data-testid={testId}>
        Memuat…
      </span>
    );
  }

  return (
    <a
      className={`block w-12 h-12 overflow-hidden border border-taupe/20 ${className}`}
      data-testid={testId}
      href={imageUrl}
      rel="noreferrer"
      target="_blank"
      title="Buka bukti transfer"
    >
      <img
        alt="Bukti transfer"
        className="h-full w-full object-cover"
        src={imageUrl}
      />
    </a>
  );
};